<template>
  <VaLayout
    :top="{ fixed: true, order: 2 }"
    :left="{
      fixed: true,
      absolute: breakpoints.mdDown,
      order: 1,
      overlay: breakpoints.mdDown && !settings.isSidebarMinimized,
    }"
    @leftOverlayClick="settings.isSidebarMinimized = true"
  >
    <template #top>
      <VaProgressBar v-if="settings.isLoading" indeterminate :size="4" class="progress-bar-over-modal" />
      <AppNavbar :is-mobile="isMobile" />
    </template>

    <template #left>
      <AppSidebar :minimized="settings.isSidebarMinimized" :mobile="isMobile" />
    </template>

    <template #content>
      <div :class="{ minimized: settings.isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
      </div>
      <AppLayoutNavigation class="ps-4 p-2" />
      <main class="p-4 pt-0">
        <article>
          <RouterView />
        </article>
      </main>
    </template>
  </VaLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, computed } from "vue"
import { storeToRefs } from "pinia"
import { onBeforeRouteUpdate } from "vue-router"
import { useBreakpoint } from "vuestic-ui"

import { useGlobalStore } from "../stores/global-store"

import AppLayoutNavigation from "../components/app-layout-navigation/AppLayoutNavigation.vue"
import AppNavbar from "../components/navbar/AppNavbar.vue"
import AppSidebar from "../components/sidebar/AppSidebar.vue"

const GlobalStore = useGlobalStore()

const breakpoints = useBreakpoint()

const sidebarWidth = ref("16rem")
const sidebarMinimizedWidth = ref(undefined)

const isMobile = ref(false)
const isTablet = ref(false)
const { settings } = storeToRefs(GlobalStore)

const onResize = () => {
  settings.value.isSidebarMinimized = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? "0" : "4.5rem"
  sidebarWidth.value = isTablet.value ? "100%" : "16rem"
}

onMounted(() => {
  window.addEventListener("resize", onResize)
  onResize()
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    settings.value.isSidebarMinimized = true
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !settings.value.isSidebarMinimized)

const onCloseSidebarButtonClick = () => {
  settings.value.isSidebarMinimized = true
}
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}

.progress-bar-over-modal {
  z-index: 1050; /* Ensure it's higher than the modal's z-index */
  position: fixed; /* Ensure it stays at the top of the viewport */
  top: 0;
  left: 0;
  width: 100%; /* Make it span the full width of the screen */
}
</style>
